export default __webpack_public_path__ + "static/media/ButtonHelpClose.b53f0f1d.png";